<template>
  <resource-box :name="title">
    <div class="overview" slot="content">
      <template v-if="quantum.length">
        <!-- 超过 6 个时：轮播展示（每组 6 个，2 行 3 列） -->
        <el-carousel
          trigger="click"
          v-if="quantum.length >= 6"
          indicator-position="outside"
          :autoplay="true"
          class="overview-carousel"
        >
          <el-carousel-item
            v-for="(group, groupIndex) in groupedQuantum"
            :key="groupIndex"
          >
            <!-- 2 行 3 列布局容器 -->
            <div class="overview-grid">
              <div
                v-for="(item, index) in group"
                :key="index"
                class="overview-item"
              >
                <div class="overview_imgs">
                  <img
                    class="overview_imgs_icon"
                    :style="{ left: item.left }"
                    :src="item.imgurl"
                    alt=""
                  />
                  <img :src="FrameBtn" alt="" />
                </div>
                <div class="overview_content">
                  <div class="overview_content_name">{{ item.name }}</div>
                  <div class="overview_content_nums">
                    {{ item.amount ? item.amount.toFixed(2) : 0
                    }}<span>{{ item.unit }}</span>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <!-- 小于等于 6 个时：直接 2 行 3 列展示，无轮播 -->
        <div v-else class="overview-grid">
          <div
            v-for="(item, index) in quantum"
            :key="index"
            class="overview-item"
          >
            <div class="overview_imgs">
              <img
                class="overview_imgs_icon"
                :style="{ left: item.left }"
                :src="item.imgurl"
                alt=""
              />
              <img :src="FrameBtn" alt="" />
            </div>
            <div class="overview_content">
              <div class="overview_content_name">{{ item.name }}</div>
              <div class="overview_content_nums">
                {{ item.amount ? item.amount.toFixed(2) : 0
                }}<span>{{ item.unit }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <el-empty
        :image="require('@/assets/recycling/index/empty.svg')"
        description="暂无数据"
        style="height: inherit; width: 100%"
        v-else
      />
    </div>
  </resource-box>
</template>

<script>
import resourceBox from '@/views/ChinaMapData/components/common/resourceBox.vue';
import { getOverViewName } from '@/API/echarts/echarts';
import { getAreaStoreCount } from '@/API/chinaMapApi/chinaMapApi';
export default {
  name: 'dataOverview',
  components: {
    resourceBox,
  },
  data() {
    return {
      title: '各类农资储备总量',
      overviewData: [
        {
          FrameTop: require('@/assets/recycling/chinaMap/jiafei.svg'),
          typeName: '钾肥',
          key: 'PotassiumFertilizer',
          typeValue: 1010,
          left: '42%',
          id: '',
          nums: '',
          typeCode: 1,
        },
        {
          FrameTop: require('@/assets/recycling/chinaMap/niaosu.svg'),
          typeName: '尿素',
          key: 'Urea',
          typeValue: 1011,
          id: '',
          nums: '',
          typeCode: 2,
        },
        {
          FrameTop: require('@/assets/recycling/chinaMap/linfei.svg'),
          typeName: '磷肥',
          key: 'PhosphateFertilizer',
          typeValue: 1012,
          id: '',
          nums: '',
          typeCode: 3,
        },
        {
          FrameTop: require('@/assets/recycling/chinaMap/fuhefei.svg'),
          typeName: '复合肥',
          key: 'CompoundFertilizer',
          typeValue: 1013,
          id: '',
          nums: '',
          typeCode: 4,
        },
        {
          FrameTop: require('@/assets/recycling/chinaMap/zhongzi.svg'),
          typeName: '种子',
          key: 'Seed',
          typeValue: 1015,
          left: '38%',
          id: '',
          nums: '',
          typeCode: 6,
        },
        {
          FrameTop: require('@/assets/recycling/chinaMap/nongyao.svg'),
          typeName: '农药',
          key: 'Pesticide',
          typeValue: 1014,
          left: '35%',
          id: '',
          nums: '',
          typeCode: 5,
        },
      ],
      FrameBtn: require('@/assets/recycling/chinaMap/Base.svg'),
      quantum: [],
    };
  },
  props: {},
  watch: {
    '$store.state.chinaMap.dataType': {
      handler: function () {
        this.getAreaStoreAmount();
      },
    },
    '$store.state.chinaMap.timeId': {
      handler: function () {
        this.getAreaStoreAmount();
      },
    },
    '$store.state.chinaMap.currentlyMapAdcode': {
      handler: function () {
        this.getAreaStoreAmount();
      },
    },
    '$store.state.chinaMap.companyId': {
      handler: function () {
        this.getAreaStoreAmount();
      },
    },
  },
  mounted() {
    this.getAreaStoreAmount();
  },
  computed: {
    // 按每组 6 个拆分数据（2 行 3 列=6 个，适配轮播）
    groupedQuantum() {
      const groups = [];
      const chunkSize = 6; // 每组固定 6 个（2 行 3 列）
      for (let i = 0; i < this.quantum.length; i += chunkSize) {
        groups.push(this.quantum.slice(i, i + chunkSize));
      }
      return groups;
    },
  },
  methods: {
    getAreaStoreAmount() {
      let params = {
        types: this.$store.state.chinaMap.dataType == 1 ? '1,3' : '2,3',
        subId: this.$store.state.chinaMap.timeId || '',
        region: this.$store.state.chinaMap.currentlyMapAdcode || '',
        dataType: this.$store.state.chinaMap.currentlyMapAdcode
          ? this.$store.state.chinaMap.dataType
          : '',
        companyId: this.$store.state.chinaMap.companyId,
      };
      switch (this.$store.state.chinaMap.dataType) {
        case 3:
          this.$set(params, 'types', '1,2,3');
          break;
        case 1:
          this.$set(params, 'types', '1,3');
          break;
        case 2:
          this.$set(params, 'types', '2,3');
          break;
      }
      getAreaStoreCount(params).then((res) => {
        if (res.code === 200) {
          this.quantum = res.data;
          this.quantum.forEach((item, index) => {
            if (!item.imgurl) {
              item.imgurl = this.overviewData[index]?.FrameTop || '';
            } else {
              item.imgurl = window.location.origin + '/apisix' + item.imgurl;
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.overview {
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
}

.overview-carousel {
  width: 100%;
  height: 100%;

  ::v-deep .el-carousel__arrow {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(0, 153, 102, 0.8);
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;

    &:hover {
      background: rgba(0, 204, 136, 1);
    }

    i {
      color: #fff;
      font-size: 18px;
    }
  }

  ::v-deep .el-carousel__arrow--left {
    left: 10px;
  }

  ::v-deep .el-carousel__arrow--right {
    right: 10px;
  }

  ::v-deep .el-carousel__item {
    height: 100%;
    background: transparent;
    border: none;
  }
}

.overview-grid {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  gap: 8px 0;
}

.overview-item {
  flex: 0 0 calc(100% / 3);
  height: calc(100% / 2);
  box-sizing: border-box;
  padding: 0 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.overview_imgs {
  position: relative;
  padding-top: 10px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  .overview_imgs_icon {
    position: absolute;
    left: 50%;
    bottom: 60%;
    max-width: 32px;
    max-height: 32px;
    transform: translate(-50%, 50%);
    animation: bounce 2s infinite;
  }

  .overview_imgs_icon:last-child {
    left: 50%;
    transform: translate(-50%, 50%);
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: translate(-50%, 50%) translateY(0);
  }
  50% {
    transform: translate(-50%, 50%) translateY(-10px);
  }
}

.overview_content {
  text-align: center;
  margin-top: 8px;

  .overview_content_nums {
    font-size: 20px;
    color: rgba(47, 241, 255, 1);
    font-weight: 500;
    margin-left: 0;

    span {
      font-size: 12px;
      margin-left: 5px;
    }
  }

  .overview_content_name {
    font-size: 14px;
    color: #ffffff;
  }
}
</style>
